import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';
import type { QueryError } from '@montugroup/circuit-shared/utils/getQueryClient';

const client = getTsCustomerPortalClient();

type ListAvailableProductsQueryOptions = {
  enabled?: boolean;
  meta?: { error?: QueryError };
};

/**
 * Options are spread onto the underlying query rather than named parameters, so this hook never
 * has to reach into another feature's directory for its own configuration — callers pass their
 * own `meta.error`. Note `meta` is stored on the query and is last-writer-wins, so two callers
 * passing different configs would disagree; both callers currently pass the same shared constant.
 * @param options - Query options spread onto the underlying query (e.g. `enabled`, `meta.error`)
 */
export const useListAvailableProducts = (options?: ListAvailableProductsQueryOptions) => {
  const { data, error, isError, isFetching, isLoading, isRefetching, isSuccess, status, refetch } =
    client.listAvailableProducts.useQuery({
      queryKey: client.listAvailableProducts.keys,
      queryData: {},
      ...options,
    });

  return {
    response: {
      data: data?.body.data,
      error,
      isError,
      isFetching,
      isLoading,
      isRefetching,
      isSuccess,
      status,
    },
    refetch,
  };
};
